


























import Inertia from '@niknevis/inertia-vue/App'
import WebLayout from '@/modules/common/layout/components/web/WebLayout.vue'
import { moduleResolver } from '@niknevis/vue-modules'
import { PanelType } from '@/modules/shared/interfaces/panel-type'


export default {
  name: 'WebApp',

  props: {
    initialPage: {}
  },

  components: {
    Inertia,
    WebLayout
  },

  methods: {
    resolveComponent(name) {
      return moduleResolver(name, PanelType.WEB)
    }
  }
}
